var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-md-12" }, [
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.submit($event)
            }
          }
        },
        [_c("buttons", { attrs: { top: "" } })],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-12" }, [
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
            }
          }
        },
        [
          _c("h4", [_vm._v("Key Statistics")]),
          _vm._v(" "),
          _c("p", [
            _vm._v("Please enter key statistics associated with the provider.")
          ]),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("keyStats", {
            attrs: {
              show: [
                "assetsUnderManagment",
                "minimumInvestment",
                "maximumInvestment",
                "avgAmountRaised",
                "numberOfInvestments",
                "timeToExitInDays",
                "timeToExitInYears",
                "successRate",
                "averageIrrSought",
                "boardSeat",
                "femaleFocus"
              ]
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-12" }, [
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
            }
          }
        },
        [
          _c("h4", [_vm._v("Descriptions")]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("keyDescs", {
            attrs: {
              show: [
                "exitSought",
                "investorVision",
                "investorFundingGoals",
                "region",
                "entrepreneurialExperience",
                "technicalExperience",
                "additionalServices",
                "applicationProcess"
              ]
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-12" }, [
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.submit($event)
            }
          }
        },
        [_c("buttons")],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n        Please enter any relevant facts associated to the provider.\n        "
      ),
      _c("small", [
        _c("i", [_vm._v("(In each case less than 500 characters)")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40f6dba7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40f6dba7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/keyFactsPage.vue
// module id = 191
// module chunks = 0